import { ParsedUrlQuery } from 'querystring';

export function getFeatures(query: ParsedUrlQuery) {
    if (query['feature']) {
        if (Array.isArray(query['feature'])) {
            return query['feature'];
        } else {
            return [query['feature']];
        }
    }

    return [];
}
